// extracted by mini-css-extract-plugin
export var input = "Switch-module--input--c7abc";
export var track = "Switch-module--track--f7c31";